import { useEffect, useState } from "react";
import {
  Alert,
  Box,
  Button,
  Link,
  Stack,
  TextField,
  Typography
} from "@mui/material";
import { Login as LoginIcon } from "@mui/icons-material";
import { getMe, login } from "../api";
import PasswordField from "../components/common/PasswordField";
import {
  AuthShell,
  ForgotPasswordPanel,
  RegisterPanel,
  ResetPasswordPanel,
  useAuthHashMode
} from "./auth/AuthPanels";

function LoginScreen({ onLoginSuccess }) {
  const hashMode = useAuthHashMode();
  const [mode, setMode] = useState(hashMode.mode);
  const [resetToken, setResetToken] = useState(hashMode.token);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    setMode(hashMode.mode);
    setResetToken(hashMode.token || "");
  }, [hashMode.mode, hashMode.token]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    try {
      await login(username, password);
      const me = await getMe();
      onLoginSuccess(me);
    } catch (err) {
      setError(err.message || "Erro ao conectar com o backend");
    }
  };

  const go = (m) => {
    setMode(m);
    if (typeof window !== "undefined") {
      window.location.hash = m === "login" ? "" : `#/${m}`;
    }
  };

  let body = null;
  if (mode === "register") body = <RegisterPanel onBack={() => go("login")} />;
  else if (mode === "forgot") body = <ForgotPasswordPanel onBack={() => go("login")} />;
  else if (mode === "reset") body = <ResetPasswordPanel token={resetToken} onBack={() => go("login")} />;
  else {
    body = (
      <>
        {String(username || "").trim().toLowerCase() === "userteste" ||
        (typeof window !== "undefined" && window.location.hostname === "76.13.164.56") ? (
          <Box sx={{ borderBottom: "1px solid rgba(200, 125, 101, 0.35)", pb: 2, mb: 1.5 }}>
            <Typography
              sx={{
                fontFamily: "'Plus Jakarta Sans', 'Inter', sans-serif",
                fontSize: "0.7rem",
                fontWeight: 600,
                letterSpacing: "0.14em",
                color: "#9C5640",
                textTransform: "uppercase"
              }}
            >
              Plataforma de Avaliação Imobiliária
            </Typography>
            <Typography
              variant="h4"
              sx={{
                fontFamily: "'Cormorant Garamond', 'Playfair Display', Georgia, serif",
                fontWeight: 400,
                fontSize: "2.4rem",
                letterSpacing: "0.06em",
                color: "#23303E",
                mt: 0.35
              }}
            >
              AVM CAIXA
            </Typography>
            <Typography
              variant="body2"
              sx={{
                fontFamily: "'Plus Jakarta Sans', 'Inter', sans-serif",
                fontSize: "0.84rem",
                color: "#52606D",
                mt: 0.5
              }}
            >
              Entre com suas credenciais para acessar o ambiente de avaliação.
            </Typography>
          </Box>
        ) : (
          <>
            <Typography variant="h4" fontWeight={800} sx={{ fontSize: "2rem", color: "#0f172a" }}>
              AVM Tecnologia Enterprise
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
              Entre com seu usuário para acessar a plataforma.
            </Typography>
          </>
        )}
        {error && (
          <Alert severity="error" sx={{ mt: 2.5, borderRadius: 3 }}>
            {error}
          </Alert>
        )}
        <Box component="form" onSubmit={handleLogin}>
          <Stack spacing={2.2} sx={{ mt: 3.2 }}>
            <TextField
              label="Usuário ou e-mail"
              name="username"
              autoComplete="username"
              placeholder="seu.usuario"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              fullWidth
              inputProps={{ "data-testid": "login-username" }}
            />
            <PasswordField
              label="Senha"
              name="password"
              autoComplete="current-password"
              placeholder="Sua senha"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              fullWidth
              inputProps={{ "data-testid": "login-password" }}
            />
            <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
              <Link
                component="button"
                type="button"
                onClick={() => go("forgot")}
                underline="hover"
                data-testid="login-forgot-link"
              >
                Esqueceu sua senha?
              </Link>
            </Box>
            <Button
              type="submit"
              variant="contained"
              size="large"
              startIcon={<LoginIcon />}
              sx={{ py: 1.35, fontWeight: 800, borderRadius: 3 }}
            >
              Entrar
            </Button>
            <Typography variant="body2" color="text.secondary" align="center">
              Ainda não tem conta?{" "}
              <Link
                component="button"
                type="button"
                onClick={() => go("register")}
                underline="hover"
                fontWeight={700}
                data-testid="login-register-link"
              >
                Faça seu cadastro
              </Link>
            </Typography>
          </Stack>
        </Box>
      </>
    );
  }

  return <AuthShell>{body}</AuthShell>;
}

export default LoginScreen;
